import Divider, { DividerProps } from '@mui/material/Divider';
import { styled } from '@mui/material/styles';

/**
 * A safe divider component that omits properties that cause issues with the MUI Tabs component.
 *
 * MUI Tabs blindly clones its children, passing all props to the DOM element, even if they are
 * not valid HTML attributes. This results in react warnings in the console.
 *
 * Might be fixed in future versions of MUI.
 */
export const TabDivider = styled(Divider, {
    shouldForwardProp: (prop: string) =>
        !['fullWidth', 'indicator', 'selectionFollowsFocus', 'textColor'].includes(prop),
})<DividerProps>``;
